export function getdata() {
	var obj = {
		searchlist: [
			{
				label: "公司代码",
				prop: "companyCode",
				type: "selectmore"
			},
			{
				label: "凭证摘要",
				prop: "voucherDesc",
				type: "input"
			},
			{
				label: "科目代码",
				prop: "accountCode",
				type: "input"
			},
			{
				label: "处理状态",
				prop: "businessMatchStatus",
				type: "select",
				selectval:[
					{
						value:'0',
						label:'未匹配'
					},{
						value:'1',
						label:'匹配成功'
					},{
						value:'2',
						label:'暂不处理'
					}
				]
			},
			{
				label: "记账日期",
				prop: "postingDate",
				type: "date",
				valueformat: 'yyyy-MM-dd'
			},
			{
				label: "业务类型",
				prop: "businessType",
				type: "select",
				selectval: []
			},
			{
				prop: "dataSource",
				label: '来源',
				type: "select",
				selectval:[
					{
						value:'0',
						label:'文件导入'
					},{
						value:'1',
						label:'接口推送'
					}
				]
			},
			{
				label: "凭证日期",
				prop: "voucherDate",
				type: "date",
				valueformat: 'yyyy-MM-dd'
			},
			{
				prop: "accouting",
				label: '记账人',
				type: "input"
			},
			{
				prop: "voucherNo",
				label: '凭证号',
				type: "input"
			}
		],
		searchdata: {
			companyCode: "",
			voucherDesc: "",
			accountCode: "",
			businessMatchStatus: "",
			postingDate: [],
			businessType: "",
			voucherDate: [],
			dataSource: "",
			accounting: "",
			voucherNo: "",
			batchNo: "",
			ids: "",
		},
		headData: [
			{
				prop: "batchNo",
				title: '批次号',
				width: 100,
				custom:true
			},
			{
				prop: "companyCode",
				title: '公司代码',
				width: 80,
				custom:true
			},
			{
				prop: "accountCode",
				title: '科目代码',
				width: 80,
				custom:true
			},
			{
				prop: "accountDesc",
				title: '科目描述',
				width: 100,
				custom:true
			},
			{
				prop: "voucherDesc",
				title: '凭证摘要',
				width: 100,
				custom:true
			},
			{
				prop: "businessType",
				title: '业务类型',
				width: 100,
				custom:true
			},
			{
				prop: "businessMatchStatus",
				title: '处理状态',
				width: 80,
				custom:true
			},
			{
				prop: "voucherType",
				title: '凭证类型',
				width: 80,
				custom:true
			},
			{
				prop: "voucherNo",
				title: '凭证号',
				width: 100,
				custom:true
			},
			{
				prop: "postingDate",
				title: '记账日期',
				width: 90,
				custom:true
			},
			{
				prop: "voucherDate",
				title: '凭证日期',
				width: 90,
				custom:true
			},
			{
				prop: "currency",
				title: '币种',
				width: 60,
				custom:true
			},
			{
				prop: "oriAmount",
				title: '原币发生额',
				width: 90,
				AmountFormat: true,
				custom:true
			},
			{
				prop: "localAmount",
				title: '本币发生额',
				width: 90,
				AmountFormat: true,
				custom:true
			},
			{
				prop: "taxCode",
				title: '税码',
				width: 80,
				custom:true
			},
			{
				prop: "taxRate",
				title: '税率',
				width: 60,
				custom:true
			},
			{
				prop: "debitOrCredit",
				title: '借/贷方',
				width: 70,
				custom:true
			},
			{
				prop: "accounting",
				title: '记账人',
				width: 80,
				custom:true
			},
			{
				prop: "billingNo",
				title: 'billingNo',
				width: 80,
				custom:true
			},
			{
				prop: "dataSource",
				title: '来源',
				width: 70,
				custom:true
			},
			{
				prop: "reference1",
				title: '参考字段一',
				width: 90,
				custom:true
			},
			{
				prop: "reference2",
				title: '参考字段二',
				width: 90,
				custom:true
			},
			{
				prop: "reference3",
				title: '参考字段三',
				width: 90,
				custom:true
			},
			{
				prop: "reference4",
				title: '参考字段四',
				width: 90,
				custom:true
			},
			{
				prop: "reference5",
				title: '参考字段五',
				width: 90,
				custom:true
			}
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
